import React from 'react';
import styles from './InputStake.module.scss';
import classNames from 'classnames';

/* Assets */
import SVG from 'react-inlinesvg';
import arrow from '../../../assets/icons/icons-app-bar-back.svg';

interface InputStakeSelectionProps {
  previous: number | undefined;
  value: number;
  next: number | undefined;
  handleNext: () => void;
  handlePrevious: () => void;
  isSuperStakeAvailable: boolean;
  untilAvailable: { days: number; hours: number; minutes: number };
}

export const InputStakeSelection: React.FC<InputStakeSelectionProps> = ({
  previous,
  next,
  value,
  handleNext,
  handlePrevious,
  isSuperStakeAvailable,
  untilAvailable,
}) => {
  const cx = classNames.bind(styles);

  return (
    <>
      <div className={styles.InputStakeSelection}>
        <button
          disabled={!previous}
          onClick={() => {
            handlePrevious();
          }}
          className={cx(styles.StakeSelectionBtn, styles.previous)}
        >
          <SVG src={arrow} className={cx(styles.arrow, styles.previous)} />
        </button>

        <div
          className={
            previous
              ? cx(styles.valueBox, styles.lowOpacity)
              : cx(styles.valueBox, styles.lowOpacity, styles.emptyBox)
          }
        >
          {previous}
        </div>

        <div className={styles.valueBox}>{value}</div>

        <div
          className={
            next
              ? cx(styles.valueBox, styles.lowOpacity)
              : cx(styles.valueBox, styles.lowOpacity, styles.emptyBox)
          }
        >
          {next}
        </div>
        <button
          onClick={() => {
            handleNext();
          }}
          className={cx(styles.StakeSelectionBtn, styles.next)}
          disabled={!next}
        >
          <SVG src={arrow} className={cx(styles.arrow, styles.next)} />
        </button>
      </div>

      {/* {value === 20 && (
        <div className={styles.superStakeWrapper}>
          <h2>{tr(t, 'super-stake')}</h2>
          {isSuperStakeAvailable ? (
            <>
              <p>{tr(t, 'super-stake-info1')}</p>
              <p>{tr(t, 'super-stake-info2')}</p>
            </>
          ) : (
            <>
              <label className={styles.red}>
                {tr(t, 'super-stake-already-used')}
              </label>
              {untilAvailable.days === 0 && untilAvailable.hours === 0 ? (
                <p>
                  {t('super-stake-available-in-minutes', {
                    minutes: untilAvailable.minutes,
                  })}
                </p>
              ) : (
                <p>
                  {t('super-stake-available-in', {
                    hours: `${untilAvailable.hours}`,
                    days: `${untilAvailable.days}`,
                  })}
                </p>
              )}
            </>
          )}
        </div>
      )} */}
    </>
  );
};
